export default __webpack_public_path__ + "static/media/gallery - euphoria_01.88b981df.jpg";